<div class="conteneur">
    <div class="row col-md-2 colonne-workflow-declaration" style="margin-top: 40px;">
        <div class="col-md-5">
            <ul id="progressbar" style="padding-left: 30px;">
                <li class="active"></li>
                <!--<li *ngIf="!isDeclarantMOA"></li>-->
                <li></li>
                <li></li>
                <li *ngIf="declaration.typeDeclarationId == 1800"></li>
            </ul>
        </div>

        <div class="col-md-7">
            <ul id="progressbar2" style="padding-left: 0px;">
                <li class="active">Déclaration</li>
                <!--<li *ngIf="!isDeclarantMOA">Maitre d'Ouvrage</li>-->
                <li>Ouvrage(s)</li>
                <li *ngIf="declaration.typeDeclarationId == 1800">Compléments</li>
                <li>Synthèse</li>
            </ul>
        </div>
    </div>

        <div class = "colonne-liste-ouvrages">
                <div class="zone-nom-projet">
                    <label class="label-projet">Projet</label>
                    <label class="label-nom-projet">{{ declaration.nomProjet }}</label>
                    <label class="label-date-projet">DU {{ declaration.dateDebutTravaux | date:'dd/MM/yyyy' }} AU {{ declaration.dateFinTravaux | date:'dd/MM/yyyy' }}</label>
                </div>

                <div *ngIf="declaration.plusieursOuvrages">
                    <button class="btn btn-success btn-md mt-2 ml-2"
                            (click)="creerNouvelOuvrage()">Ajouter un ouvrage</button>

                    <div class="formulaire-multi-ouvrage">
                        <label>Relation entre les ouvrages<span class="asterisk-red">*</span></label>
                        <ng-select id="field_relation" name="relation" [(ngModel)]="declaration.relationId" class="col-md-6 dropdown-no-padding">
                            <ng-option [value]="lexRelationOption.id" *ngFor="let lexRelationOption of lexrelations" [hidden]="!lexRelationOption.valide">{{lexRelationOption.libelle}}</ng-option>
                        </ng-select>
                    </div>
                </div>

                <p-scrollPanel [style]="{height: '550px'}" class="alignement-icone">
                    <p-panel *ngFor="let ouvrage of declarationOuvrages.ouvrages" class="alignement-icone">
                        <div *ngIf="etape != 'Localisation' || ouvrage.nomUsuel != ouvrageForm.nomUsuel">
                            <p-header class="alignement-icone">
                                <span (click)="changeName(ouvrage)" #ouvWarn style="display:inline-block;">
                                    <span *ngIf="ouvrage.nomUsuel != ''" class="ui-panel-title nom-ouvrage-resume-ouvrage"> {{ouvrage.nomUsuel}}</span>
                                </span>
                                <input maxlength="25" #ouvName [(ngModel)]="ouvrage.nomUsuel" (change)="computeDuplicate()" (keyup.enter)="closeInput(ouvrage)" (blur)="closeInput(ouvrage)" style="display:none;" />
                                
                                <p-button icon="pi pi-trash"
                                        class="boutton-supprimer-ouvrage"
                                        (click)="cancelOuvrage(ouvrage)"></p-button>
                            </p-header>
                            <div style="font-size: 14px;cursor:pointer;">
                                <div (click)="ouvrirLocalisation(ouvrage)">
                                    <p-button title="Modifier la localisation"
                                            class="crayon"
                                            [ngClass]="choisirClasseCssLocalisationCrayon()"
                                            icon="pi pi-pencil"></p-button>
                                    <span [ngClass]="choisirClasseCssLocalisation()" 
                                        style="display:inline-block;margin-bottom: 10px"> X: {{ouvrage.x}}, Y: {{ouvrage.y}}</span>
                                </div>

                                <div (click)="ouvrirCaracteristique(ouvrage)">
                                    <p-button title="Modifier les caractéristiques"
                                            class="crayon"
                                            icon="pi pi-pencil"
                                            [ngClass]="choisirClasseCssCaracteristiqueCrayon()"></p-button>
                                    <span [ngClass]="choisirClasseCssCaracteristique()"
                                          style="display:inline-block;margin-bottom: 10px"> Type: {{ouvrage.natureOuvrageId?ouvrage.natureOuvrageLibelle+' ':''}}{{ouvrage.directionId?ouvrage.directionLibelle +' ':''}}{{ouvrage.longeur?'sur '+ouvrage.longeur+' m':''}}</span>
                                </div>

                                <div *ngIf="!isDeclarantMOE" 
                                     (click)="ouvrirMoe(ouvrage)">
                                        <p-button title="Modifier le maître d'oeuvre"
                                            class="crayon"
                                            icon="pi pi-pencil"
                                            [ngClass]="choisirClasseCssMoeCrayon()"></p-button>
                                        <span [ngClass]="choisirClasseCssMoe()"
                                            style="display:inline-block;margin-bottom: 10px"> Maître d'oeuvre : {{ouvrage.acteurMoe?(ouvrage.acteurMoe.raisonSocialeEtab?ouvrage.acteurMoe.raisonSocialeEtab:(ouvrage.acteurMoe.contact?ouvrage.acteurMoe.contact.prenom:'')):''}} {{ouvrage.acteurMoe?(ouvrage.acteurMoe.raisonSocialeEtab?'':ouvrage.acteurMoe.contact?ouvrage.acteurMoe.contact.nom:''):''}}</span>
                                </div>

                                <div *ngIf="!isDeclarantProprietaire"
                                     (click)="ouvrirProprietaire(ouvrage)">
                                    <p-button title="Modifier le propriétaire"
                                            class="crayon"
                                            icon="pi pi-pencil"
                                            [ngClass]="choisirClasseCssProprietaireCrayon()"></p-button>
                                    <span [ngClass]="choisirClasseCssProprietaire()"
                                        style="display:inline-block;margin-bottom: 10px"> Propriétaire : {{ouvrage.acteurProprio?(ouvrage.acteurProprio.raisonSocialeEtab?ouvrage.acteurProprio.raisonSocialeEtab:(ouvrage.acteurProprio.contact?ouvrage.acteurProprio.contact.prenom:'')):''}} {{ouvrage.acteurProprio?(ouvrage.acteurProprio.raisonSocialeEtab?'':ouvrage.acteurProprio.contact?ouvrage.acteurProprio.contact.nom:''):''}}</span>
                                </div>

                                <div *ngIf="!isDeclarantExploitant" 
                                     (click)="ouvrirForeur(ouvrage)">
                                    <p-button title="Modifier le foreur"
                                            class="crayon"
                                            icon="pi pi-pencil"
                                            [ngClass]="choisirClasseCssForeurCrayon()"></p-button>
                                    <span [ngClass]="choisirClasseCssForeur()"
                                        style="display:inline-block;margin-bottom: 10px">Foreur : {{ouvrage.acteurForeur?(ouvrage.acteurForeur.raisonSocialeEtab?ouvrage.acteurForeur.raisonSocialeEtab:(ouvrage.acteurForeur.contact?ouvrage.acteurForeur.contact.prenom:'')):''}} {{ouvrage.acteurForeur?(ouvrage.acteurForeur.raisonSocialeEtab?'':ouvrage.acteurForeur.contact?ouvrage.acteurForeur.contact.nom:''):''}}</span>
                                </div>

                                <div *ngIf="isEau" 
                                     (click)="ouvrirAquifere(ouvrage)">
                                    <p-button title="Modifier l'aquifère"
                                            class="crayon"
                                            icon="pi pi-pencil"
                                            [ngClass]="choisirClasseCssAquifereCrayon()"></p-button>
                                    <span [ngClass]="choisirClasseCssAquifere()"
                                          style="display:inline-block;margin-bottom: 10px"> Aquifère, eau superficielle ou source: {{ouvrage.codeNappe?ouvrage.nomNappe+' ':''}}{{ouvrage.codeNappe?'('+ouvrage.codeNappe+')':''}}</span>
                                </div>
                            </div>
                        </div>
                    </p-panel>
                </p-scrollPanel>
        </div>

        <div class = "colonne-ouvrage">
            <!-- Ce div permet d'afficher le bouton pour ajouter un ouvrage supplémentaire à la déclaration -->
            <div *ngIf="proposerAjouterOuvrage && !isDomestique">
               <button class="btn btn-success btn-md mt-2 ml-2"
                       (click)="creerNouvelOuvrage()">Ajouter un ouvrage</button>
            </div>

            <!-- Ce div permet d'afficher le message d'erreur si le volume de prelevement d'eau de l'ouvrage est supérieur à celui indiqué dans la declaration. 
                 Pour un forage domestique -->
            <div *ngIf="isDomestique && totalPrelevementOuvrage > declaration.prelevement"
                 style="color:red;">
                Le volume d'eau prélevé déclaré sur l'ouvrage ne doit pas être supérieur au volume indiqué dans la déclaration. <br>
                Volume renseigné sur la déclaration : {{declaration.prelevement}} <br>
                Volume renseigné sur l'ouvrage : {{ouvrageForm.prelevement}}. <br>
                Merci de corriger le volume saisi pour l'ouvrage ou dans la déclaration
            </div>

            <!-- Ce div permet d'affichier le message d'erreur si le volume total prélevé par les différents ouvrages est inférieur à celui indiqué dans la declaration. 
                 Pour un forage non domestique-->
            <div *ngIf="!isDomestique && totalPrelevementOuvrage < declaration.prelevement"
                 style="color: red;">
                Le volume total d'eau prélevée par l'ensemble des ouvrages est inférieur au volume d'eau indiqué dans la déclaration. <br>
                Volume renseigné sur la déclaration : {{declaration.prelevement}} <br>
                Volume total renseigné sur les ouvrages : {{totalPrelevementOuvrage}}. <br>
                Merci de corriger le volume saisi pour l'ouvrage ou dans la déclaration
            </div>

            <!-- Ce div permet d'afficher un message indiquant qu'un forage domestique ne peut contenir qu'un seul ouvrage -->
            <!--<div *ngIf="proposerAjouterOuvrage && isDomestique">
                Les forages domestiques (forage dont le volume d'eau prélévé ne dépasse pas les 1000 m3) ne peuvent contenir qu'un seul ouvrage. <br>
                Nous vous invitons à terminer votre déclaration en cliquant sur le bouton "Suivant" au bas de l'écran. 
            </div>-->

            <!-- Ce div contient le formulaire permettant de renseigner le nom d'un ouvrage -->
            <div *ngIf="etape === 'Nom'">
                <div class="formulaire-nom-ouvrage">
                    <span *ngIf="duplicateNomUsuel.has(ouvrageForm.nomUsuel)"
                           style="color:red;">Les ouvrages doivent avoir des noms tous différents</span>

                    <label class="label-nom-ouvrage">Nom de l'ouvrage<span class="asterisk-red">*</span></label>
                    <input id="nomOuvrage" 
                           class="input-nom-ouvrage"
                           type="text"
                           placeholder="Nom"
                           [(ngModel)]="ouvrageForm.nomUsuel">

                    <!-- Dans le cas où il existe déjà un ouvrage dans la liste declarationOuvrages, il faut indiquer la relation entre les ouvrages -->
                    <div *ngIf="declarationOuvrages.ouvrages.length >= 1" 
                          class="formulaire-multi-ouvrage">
                        <label>Relation entre les ouvrages<span class="asterisk-red">*</span></label>
                        <ng-select id="field_relation" name="relation" [(ngModel)]="declaration.relationId" class="col-md-6 dropdown-no-padding">
                            <ng-option [value]="lexRelationOption.id" *ngFor="let lexRelationOption of lexrelations" [hidden]="!lexRelationOption.valide">{{lexRelationOption.libelle}}</ng-option>
                        </ng-select>

                        <br>
                        <input type="checkbox" [(ngModel)]="isSame" (change)="same($event)">Copier automatiquement les informations du premier ouvrage
                    </div>   

                    <div class="boutons">
                        <button class="btn btn-secondary btn-md"
                                (click)="annulerDeclaration()">Annuler</button>

                        <button class="btn btn-md"
                                [ngClass]="{ 'btn-secondary': !ouvrageForm.nomUsuel, 'btn-success': ouvrageForm.nomUsuel }"
                                [disabled]="!nouvelOuvrageValide() || duplicateNomUsuel.has(ouvrageForm.nomUsuel)"
                                (click)="ajouterOuvrage()">Suivant</button>
                    </div>
                </div>
            </div>

            <div *ngIf="!afficherFormulaireNomOuvrage && !proposerAjouterOuvrage">
                <label class="label-ouvrage">Ouvrage</label>
                <label class="label-nom-ouvrage">{{ ouvrageForm.nomUsuel }}</label>
            </div>

                    
            <!-- Le div pour saisir la localisation de l'ouvrage, par la carte ou par le formulaire -->
            <div *ngIf="etape === 'Localisation'">
                <div class="entete-localisation">
                    <label class="label-localisation">Localisation <span *ngIf="displayCarte && ouvrageForm.x != undefined && ouvrageForm.y != undefined" style="color:blue">X: {{ouvrageForm.x}}, Y: {{ouvrageForm.y}}</span></label>
                    <div class="changement-saisie-localisation">
                        <label class="label-positionner-carte" [ngStyle]="{'font-weight': displayCarte ? 'bold': ''}">Positionner sur la carte</label>
                        <p-inputSwitch (onChange)="changerSaisieCoordonnees()" 
                                       [(ngModel)]="!displayCarte"></p-inputSwitch>
                        <label class="label-positionner-coordonnees" [ngStyle]="{'font-weight': !displayCarte ? 'bold': ''}">Saisir les coordonnées</label>
                    </div>
                </div>

                <span *ngIf="!isCoordonneeValide()" style="color: red; font-weight: bold; width: 100%">Positionnement impossible : la localisation souhaitée est en dehors des régions couvertes par DUPLOS.</span>

                <div *ngIf="displayCarte" class="affichage-carte">
                            <ol-map [(declaration)]="declaration" 
                                    [(ouvrage)]="ouvrageForm"
                                    [declarationOuvrages]="declarationOuvrages"
                                    [tick]="tick" 
                                    [isSame]="isSame"
                                    [nomOuvrage]="ouvrageForm.nomUsuel"
                                    (coord_valide_child)= "validerCoordonneeCarte($event)"></ol-map>
                </div>
                
                <div *ngIf="!displayCarte">
                    <dup-localisation [ouvrage]="ouvrageForm" 
                                      [nomOuvrage]="ouvrageForm.nomUsuel"
                                      [declarationOuvrages]="declarationOuvrages"
                                      [isCarte]="isCarte()" 
                                      [perimetre]="perimetre" 
                                      (coord_valide_child)= "validerCoordonneeFormulaire($event)"></dup-localisation>
                </div>

                <div class="boutons-formulaire">
                    <button class="btn btn-secondary btn-md"
                            (click)="annulerLocalisation()">Annuler</button>
                    <button class="btn btn-md"
                            [ngClass]="{ 'btn-secondary': !validateLocalisation(ouvrageForm), 'btn-success': validateLocalisation(ouvrageForm) }"
                            [disabled]="!validateLocalisation(ouvrageForm)"
                            (click)="remplirCoordonnees()">Suivant</button>
                </div>
            </div>

            <!-- Le div pour saisir les caracteristiques de l'ouvrage -->
            <div *ngIf="etape === 'Caracteristique'">
                    <dup-carac-ouvrage [ouvrage]="ouvrageForm" 
                                       [isEau]="isEau" 
                                       [isDomestique]="isDomestique"
                                       [volumePrelevementEau]="declaration.prelevement"
                                       (changementVolume)="checkPrelevement()"></dup-carac-ouvrage>

                    <div class="boutons-formulaire">
                        <button class="btn btn-secondary btn-md"
                                (click)="annulerCaracteristique()">Précédent</button>
                        <button *ngIf="isEau || !isDeclarantMOE || !isDeclarantProprietaire || !isDeclarantExploitant"
                                class="btn btn-md"
                                [ngClass]="{ 'btn-secondary': !validateCarac(ouvrageForm), 'btn-success': validateCarac(ouvrageForm) }"
                                [disabled]="!validateCarac(ouvrageForm)"
                                (click)="validerEtapeCaracteristique()">Suivant</button>

                        <button *ngIf="isDeclarantMOE && isDeclarantProprietaire"
                                class="btn btn-md"
                                [ngClass]="{ 'btn-secondary': !validateCarac(ouvrageForm), 'btn-success': validateCarac(ouvrageForm) }"
                                [disabled]="!validateCarac(ouvrageForm)"
                                (click)="terminerOuvrage()">Terminer</button>
                    </div>
            </div>

            <!-- Le div pour saisir les informations du Maitre d'Oeuvre -->
            <div *ngIf="etape === 'MOE'">
                    <p-scrollPanel [style]="{height: '500px'}">
                        <h2 class="modal-title modal-header" style="padding-left: 1rem; padding-bottom: 1rem;">Maître d'oeuvre</h2>
                        
                        <div class="modal-body col-md-12" id="dup-acteur-popup">
                            <label class="col-md-5 form-control-label" *ngIf="declaration.acteurMoa && declaration.acteurMoa.email">Identique au maitre d'ouvrage</label>
                            <input type="checkbox" class="col-md-1" name="identMoe"  *ngIf="declaration.acteurMoa && declaration.acteurMoa.email" (change)="ident('Maitre oeuvre')" />
                            <dup-acteur-form [acteur]="ouvrageForm.acteurMoe"></dup-acteur-form>
                        </div>
                    </p-scrollPanel>

                    <div class="boutons-formulaire">
                        <button class="btn btn-secondary btn-md"
                                (click)="annulerMaitreOeuvre()">Précédent</button>
                        <button class="btn btn-md"
                                [ngClass]="{ 'btn-secondary': !validateActeur(ouvrageForm.acteurMoe), 'btn-success': validateActeur(ouvrageForm.acteurMoe) }"
                                (click)="validerEtapeMoe()"
                                [disabled]="!validateActeur(ouvrageForm.acteurMoe)"
                                *ngIf="isEau || !isDeclarantProprietaire || !isDeclarantExploitant">Suivant</button>
                        <button *ngIf="isDeclarantProprietaire" 
                                class="btn btn-md"
                                [ngClass]="{ 'btn-secondary': !validateActeur(ouvrageForm.acteurMoe), 'btn-success': validateActeur(ouvrageForm.acteurMoe) }"
                                (click)="terminerOuvrage()">Terminer</button>
                    </div>
            </div>

            <!-- Le div pour saisir les informations du Proprietaire -->
            <div *ngIf="etape === 'Proprietaire'">
                    <p-scrollPanel [style]="{height: '500px'}">
                        <h2 class="modal-title modal-header" style="padding-left: 1rem; padding-bottom: 1rem;">Propriétaire</h2>
                        
                        <div class="modal-body col-md-12" id="dup-acteur-popup">
                            <label class="col-md-5 form-control-label" *ngIf="declaration.acteurMoa && declaration.acteurMoa.email">Identique au maitre d'ouvrage</label>
                            <input type="checkbox" class="col-md-1" name="identProprietaire" *ngIf="declaration.acteurMoa && declaration.acteurMoa.email" (change)="ident('Proprietaire')" />
                            <dup-acteur-form [acteur]="ouvrageForm.acteurProprio"></dup-acteur-form>
                        </div>
                    </p-scrollPanel>

                    <div class="boutons-formulaire">
                        <button class="btn btn-secondary btn-md"
                                (click)="annulerProprietaire()">Précédent</button>
                        <button class="btn btn-md"
                                [ngClass]="{ 'btn-secondary': !validateActeur(ouvrageForm.acteurProprio), 'btn-success': validateActeur(ouvrageForm.acteurProprio) }"
                                (click)="validerEtapeProprietaire()"
                                [disabled]="!validateActeur(ouvrageForm.acteurProprio)"
                                *ngIf="isEau || !isDeclarantProprietaire">Suivant</button>
                        
                        <button class="btn btn-md"
                                [ngClass]="{ 'btn-secondary': !validateActeur(ouvrageForm.acteurProprio), 'btn-success': validateActeur(ouvrageForm.acteurProprio) }"
                                [disabled]="!validateActeur(ouvrageForm.acteurProprio)" 
                                (click)="terminerOuvrage()">Terminer</button>
                    </div>
            </div>

            <!-- Le div pour saisir les informations du Foreur -->
            <div *ngIf="etape === 'Foreur'">
                    <p-scrollPanel [style]="{height: '500px'}">
                        <h2 class="modal-title modal-header" style="padding-left: 1rem; padding-bottom: 1rem;">Foreur</h2>
                        
                        <div class="modal-body col-md-12" id="dup-acteur-popup">
                            <label class="col-md-5 form-control-label" *ngIf="declaration.acteurMoa && declaration.acteurMoa.email">Identique au maitre d'ouvrage</label>
                            <input type="checkbox" class="col-md-1" name="identForeur" *ngIf="declaration.acteurMoa && declaration.acteurMoa.email" (change)="ident('Foreur')" />
                            <dup-acteur-form [acteur]="ouvrageForm.acteurForeur"></dup-acteur-form>
                        </div>
                    </p-scrollPanel>

                    <div class="boutons-formulaire">
                        <button class="btn btn-secondary btn-md"
                                (click)="annulerForeur()">Précédent</button>

                        <button *ngIf="isEau"
                                class="btn btn-md btn-success"
                                (click)="validerEtapeForeur()">Suivant</button>

                        <button class="btn btn-md btn-success"
                                (click)="terminerOuvrage()">Terminer</button>
                    </div>
            </div>

            <!-- Le div pour saisir les informations de l'Aquifere -->
            <div *ngIf="etape === 'Aquifere'">
                <dup-aquifere [ouvrage]="ouvrageForm" [srs]="getSrs()"></dup-aquifere>
                <div class="boutons-formulaire">
                    <button class="btn btn-secondary btn-md"
                            (click)="annulerAquifere()">Précédent</button>

                     <button [ngClass]="{ 'btn btn-secondary btn-md': !isCaracteristiquesValides(), 'btn btn-success btn-md': isCaracteristiquesValides() }"
                             (click)="terminerOuvrage()">Terminer</button>
                 </div>
            </div>
        </div>
</div>